module.exports = __webpack_public_path__ + "static/description-6f7d1c25c6ca29932f11fa5668ea8205.png";